import { useState } from "react";
import { useNotify } from "react-admin";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import useStyles from "./style";
import { usePageTitle } from "@/utilities";

const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:3000/api";

const ResetPasswordPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const notify = useNotify();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token") ?? "";

  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  usePageTitle("Nouveau mot de passe");

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!token) {
      notify("Le lien de réinitialisation est invalide.", {
        type: "warning",
      });
      return;
    }

    if (password !== confirmation) {
      notify("Les mots de passe ne correspondent pas.", {
        type: "warning",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${API_URL}/auth/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token, password }),
      });

      if (!response.ok) {
        throw new Error("Reset failed");
      }

      notify("Votre mot de passe a été modifié.", {
        type: "success",
      });

      navigate("/login");
    } catch {
      notify("Ce lien est invalide ou a expiré.", {
        type: "warning",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.leftPane}>
        <Box
          component="img"
          src="/logo-gameoo.png"
          alt="GAMEOO"
          className={classes.brand}
        />

        <div className={classes.formWrap}>
          <div className={classes.form}>
            <Typography variant="h4" className={classes.title}>
              Nouveau mot de passe
            </Typography>

            {!token ? (
              <>
                <Typography sx={{ mb: 3 }}>
                  Ce lien de réinitialisation est invalide.
                </Typography>

                <Button
                  className={classes.buttonLogIn}
                  variant="contained"
                  onClick={() => navigate("/forgot-password")}
                >
                  Demander un nouveau lien
                </Button>
              </>
            ) : (
              <form onSubmit={handleSubmit}>
                <TextField
                  className={classes.input}
                  label="Nouveau mot de passe"
                  type="password"
                  value={password}
                  required
                  fullWidth
                  autoComplete="new-password"
                  inputProps={{ minLength: 8 }}
                  onChange={(event) => setPassword(event.target.value)}
                  sx={{ mb: 2 }}
                />

                <TextField
                  className={classes.input}
                  label="Confirmer le mot de passe"
                  type="password"
                  value={confirmation}
                  required
                  fullWidth
                  autoComplete="new-password"
                  inputProps={{ minLength: 8 }}
                  onChange={(event) => setConfirmation(event.target.value)}
                  sx={{ mb: 2 }}
                />

                <Button
                  className={classes.buttonLogIn}
                  type="submit"
                  variant="contained"
                  disabled={isSubmitting}
                >
                  {isSubmitting
                    ? "Modification en cours…"
                    : "Modifier le mot de passe"}
                </Button>
              </form>
            )}
          </div>
        </div>
      </div>

      <div className={classes.rightPane} aria-hidden />
    </div>
  );
};

export default ResetPasswordPage;
